module.exports = __webpack_public_path__ + "static/media/near-me-dark.a29409d1.svg";